module.exports = __webpack_public_path__ + "static/media/Version.0993bf98.txt";


//////////////////
// WEBPACK FOOTER
// ./src/Version.txt
// module id = 127
// module chunks = 1